import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";

const STORAGE_KEY = "tutorial_videos_active_tab";

const tabsList = [
  { id: 1, name: "Languages", route: "/tutorial-languages" },
  { id: 2, name: "Categories", route: "/tutorial-categories" },
  { id: 3, name: "Videos", route: "/videos-list" },
  {
    id: 4,
    name: "AnnouncementBanner/video",
    route: "/annoucement-banner-list",
  },
];

const TutorialVideos = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(() => {
    const savedId = Number(sessionStorage.getItem(STORAGE_KEY));
    return tabsList.find((t) => t.id === savedId) ?? tabsList[0];
  });

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem(STORAGE_KEY, tab.id);
    navigate(tab.route);
  };

  return (
    <div>
      <Topbar header={"Tutorial Videos"} />
      <div className="d-flex flex-wrap gap-3">
        {tabsList.map((tab) => (
          <div
            key={tab.id}
            onClick={() => handleTabClick(tab)}
            className={`${
              activeTab.id === tab.id ? "Act-tabs" : "tabs"
            } d-flex ac-jc pointer px-3`}
          >
            <p className="text-wrap">{tab.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TutorialVideos;
